<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="90px"
      class="demo-ruleForm"
    >
      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="主题名称:" prop="title">
            <el-input v-model="ruleForm.title" placeholder="必填，2-40个字"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模板名:" prop="theme">
            <el-input v-model="ruleForm.theme" @input="accountInput" placeholder="必填，2-20个字，英文+数字"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="状态:">
            <el-radio-group v-model="ruleForm.status" :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'">
              <el-radio-button label="0">禁用</el-radio-button>
              <el-radio-button label="1">启用</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预览图:" prop="password">
            <el-upload
              class="upload-demo"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="onChange"
            >
              <div :style="{'fontSize':'12px','color': isSimple ? '#E27B02' : '#194897'}" v-if="!thumbnailFile">+ 上传图片</div>
            </el-upload>

            <div v-if="thumbnailFile" class="imgbj">
              <el-image
                lazy
                class="imgs"
                :src="thumbnailFile.src"
                :preview-src-list="[thumbnailFile.src]"
              ></el-image>
              <p :style="{'color': isSimple ? '#E27B02' : '#194897'}" @click.stop="deleteThumbnailFile" class="delete">删除</p>
              <!-- <div @click.stop="deleteThumbnailFile" class="delete">
                <img width="15px" src="@/assets/piclist/mydel.png" alt />
              </div> -->
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-form-item label="简介:" prop="desc">
          <el-input
            type="textarea"
            :autosize="{ minRows: 8, maxRows: 12}"
            v-model="ruleForm.desc"
            placeholder="选填，用户备注不超过200个字"
          ></el-input>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="bottombtn">
      <div class="btn">
        <el-button @click="closeForm">取消</el-button>
        <el-button :style="{'border':'none','backgroundColor': isSimple ? '#E27B02' : '#194897'}" @click="submitForm('ruleForm')" type="primary">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDate } from "@/plugins/getdate";
import { picPrefix } from "@/constants/piccommon";
import {
  uploadPic
} from "@/api/file";
export default {
  props: {
    ruleForm: Object
  },
  data() {
    return {
      picPrefix,
      thumbnailFile: null,
      
      isUpdata:false,

      rules: {
        title: [
          { required: true, message: "请输入主题名称", trigger: "blur" },
          { min: 2, max: 40, message: "长度在 2 到 40 个字符", trigger: "blur" }
        ],
        theme: [
          { required: true, message: "请输入模板名", trigger: "change" },
          { min: 2, max: 20, message: "长度在2-20个字符", trigger: "blur" }
        ],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.thumbnailFile === null) {
            this.$message.warning("请上传预览图！");
          } else {
            this.ruleForm.thumb = this.thumbnailFile.thumb;
            // console.log(this.ruleForm)
            if(this.isUpdata){
              this.$emit("updataForm", this.ruleForm);
            }else{
              this.$emit("submitForm", this.ruleForm);
            }
            
          }
          
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeForm() {
      this.$emit("closeForm");
    },

    accountInput(val) {
      let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
        len = val.length,
        str = "";
      for (var i = 0; i < len; i++) {
        if (codeReg.test(val[i])) {
          str += val[i];
        }
      }
      this.ruleForm.theme = str;
    },

    deleteThumbnailFile() {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.thumbnailFile = null;
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },



    onChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 10;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)

      let fd = new FormData();
      fd.append("file", file.raw);
      this.uploadPicAsync(fd);
    },

    //常规文件上传
    async uploadPicAsync(val) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        this.thumbnailFile = val;
        this.thumbnailFile.src = picPrefix + data.savepath;
        this.thumbnailFile.thumb = data.savepath;
      }else{
        this.$message.error("上传失败，请重新选择！")
      }
    },
  },
  created() {
    if(this.ruleForm.title){
      this.isUpdata = true
    }
    if(this.ruleForm.thumb){
      this.thumbnailFile = {
        src : picPrefix + this.ruleForm.thumb
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 2px;
  // top: 0;
  // z-index: 99;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn ::v-deep .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn ::v-deep .el-button--primary {
  background-color: #185ed3;
}
::v-deep .el-form-item__label {
  font-weight: 600;
}

.xianzhi {
  font-size: 13px;
  color: red;
  margin: -15px 0 0 90px;
}

.imgbj {
  // &:hover .delete {
  //   opacity: 1;
  // }

  .imgs {
    width: 50px;
    height: 50px;
    position: absolute;
    top: -10px;
    left: 5px;
  }

  .delete {
    position: absolute;
    top: 15px;
    left: 60px;
    transform: 0.5s;
    opacity: 1;
    color: #185ed3;
    cursor: pointer;
  }
}
</style>
